import React, { Component } from 'react';

import Banner_Img from '../../assets/images/banner-inner.jpg';


class Banner extends Component {
    render() {
        const styleElements = {
            backgroundImage: 'url(' + Banner_Img + ')'
        };
        return (
            <section className="banner bannerInner" style={styleElements}>
                {/* <div className="bannerCaption">
                    <div className="container">
                    </div>
                </div> */}
            </section>
        );
    }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/index.js